import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagsService {
  private flags = new BehaviorSubject<Record<string, any>>({});

  setFlags(features: Record<string, boolean>): void {
    this.flags.next(features);
  }

  getFlags$() {
    return this.flags.asObservable();
  }

  hasFlag(flag: string): boolean {
    return this.flags.getValue()[flag];
  }
}
